import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Chip, CircularProgress } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { MediaInProgressLoader } from './MediaInProgressLoader';
import { useFragmentMediaRegeneration } from './useFragmentMediaRegeneration';

const regenerateMessage = defineMessage({
  id: 'fragments.mediaStatus.regenerate',
  defaultMessage: 'Sin progreso? Regenerar media',
});

interface FragmentMediaStalledLoaderProps {
  /** Export progress percent while the media asset is being generated. */
  progressPercent?: number;
}

/**
 * Overlay when media generation is stalled: keeps the normal progress loader
 * and adds a regenerate chip action.
 */
export function FragmentMediaStalledLoader({ progressPercent }: FragmentMediaStalledLoaderProps) {
  const { $t } = useIntl();
  const { regenerate, isPending } = useFragmentMediaRegeneration();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        px: 2,
      }}
    >
      <MediaInProgressLoader progressPercent={progressPercent} />
      <Chip
        label={$t(regenerateMessage)}
        onClick={regenerate}
        disabled={isPending}
        icon={isPending ? <CircularProgress size={16} color="inherit" /> : <RefreshIcon />}
        size="small"
        variant="outlined"
      />
    </Box>
  );
}
